<template>
  <div class="list-builder" ref="listBuilder">
    <ItemsListComponent
      ref="availableItemsList"
      :title="availableItemsTitle"
      :selectAllLabel="selectAllLabel"
      :listItems="listItems"
      @selectItem="selectAvailableItem"
      @selectItems="selectAvailableItems"
      @unselectAllItems="unselectAllAvailableItems"
      @unselectItem="unselectAvailableItem">
    </ItemsListComponent>

    <div class="transfer-buttons">
      <button
        class="btn add-button"
        :disabled="selectedAvailableItems.length === 0"
        @click="assignSelectedItems()">
        <i class="icon icon-chevron-right"></i>
      </button>
      <button
        class="btn remove-button"
        :disabled="selectedAssignedItems.length === 0"
        @click="unassignSelectedItems()">
        <i class="icon icon-chevron-left"></i>
      </button>
    </div>

    <ItemsListComponent
      :title="assignedItemsTitle"
      :selectAllLabel="selectAllLabel"
      @selectItem="selectAssignedItem"
      @selectItems="selectAssignedItems"
      @unselectAllItems="unselectAllAssignedItems"
      @unselectItem="unselectAssignedItem"
      ref="assignedItemsList">
    </ItemsListComponent>
  </div>
</template>

<script>
import ItemsListComponent from './ItemsListComponent.vue';

export default {
  components: {
    ItemsListComponent
  },
  props: {
    listItems: {
      type: Array,
      default: []
    },
    availableItemsTitle: {
      type: String,
      default: ''
    },
    assignedItemsTitle: {
      type: String,
      default: ''
    },
    selectAllLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      availableItemsListComponent: undefined,
      assignedItemsListComponent: undefined,
      selectedAvailableItems: [],
      selectedAssignedItems: []
    }
  },
  methods: {
    assignSelectedItems() {
      this.availableItemsListComponent.removeItems(this.selectedAvailableItems);
      this.assignedItemsListComponent.addItems(this.selectedAvailableItems);

      this.$emit('itemsAssigned', this.selectedAvailableItems);

      this.selectedAvailableItems = [];
    },
    unassignSelectedItems() {
      this.assignedItemsListComponent.removeItems(this.selectedAssignedItems);
      this.availableItemsListComponent.addItems(this.selectedAssignedItems);

      this.$emit('itemsUnassigned', this.selectedAssignedItems);

      this.selectedAssignedItems = [];
    },
    selectAvailableItem(listItem) {
      this.selectedAvailableItems.push(listItem);
    },
    selectAvailableItems(listItems) {
      this.selectedAvailableItems = listItems;
    },
    unselectAvailableItem(listItem) {
      this.selectedAvailableItems = this.selectedAvailableItems.filter(item => item.key !== listItem.key);
    },
    unselectAllAvailableItems() {
      this.selectedAvailableItems = [];
    },
    selectAssignedItem(listItem) {
      this.selectedAssignedItems.push(listItem);
    },
    selectAssignedItems(listItems) {
      this.selectedAssignedItems = listItems;
    },
    unselectAssignedItem(listItem) {
      this.selectedAssignedItems = this.selectedAssignedItems.filter(item => item.key !== listItem.key);
    },
    unselectAllAssignedItems() {
      this.selectedAssignedItems = [];
    },
    clear() {
      this.availableItemsListComponent.clear();
      this.assignedItemsListComponent.clear();
    }
  },
  mounted() {
    this.availableItemsListComponent = this.$refs.availableItemsList;
    this.assignedItemsListComponent = this.$refs.assignedItemsList;
  }
}
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';

.list-builder {
  div.transfer-buttons {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    padding: @space-large;
    min-width: 0;
    width: -webkit-fill-available;
    border: none;

    .btn {
      min-width: @space-xxl;
      width: @space-xxl;
      padding: 5px 8px 4px;
      margin: 0;

      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
